import React, { useState } from 'react';
import { DillButton, DillModal } from '../../../general/Dill';
import { AppInputField } from '../../../general/AppInputField/AppInputField';
import { CreditApplication } from '@dill/dill-shared';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { updateSupplierCreditApplication } from '../../../../redux/services/creditApplicationsService';
import { openDillToast } from '../../../../utils/helpers';

const CreditApplicationNotesModal = ({
  open,
  handleClose,
  creditApplication,
}: {
  open: boolean;
  handleClose: () => void;
  creditApplication: CreditApplication | null;
}) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  const [notes, setNotes] = useState<string>('');
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [addingNotes, setAddingNotes] = useState<boolean>(false);

  const validateInputs = () => {
    const errors: string[] = [];
    if (notes.trim() === '') errors.push('notes');

    setErrorFields(errors);
    return errors.length === 0;
  };

  const handleCloseModal = () => {
    setNotes('');
    setErrorFields([]);
    setAddingNotes(false);
    handleClose();
  };

  const handleSubmit = async () => {
    if (!validateInputs()) return;
    if (!creditApplication) return;
    setAddingNotes(true);
    const results = await dispatch(
      updateSupplierCreditApplication({
        supplierId: currentSupplier?.id || '',
        creditApplicationId: creditApplication.id,
        notes: notes.trim(),
      })
    );
    if (results.type.includes('fulfilled')) {
      openDillToast({
        type: 'SUCCESS',
        message: 'Notes added successfully.',
      });
      setAddingNotes(false);
      handleCloseModal();
    } else {
      openDillToast({
        type: 'ERROR',
        message: 'Failed to add notes.',
      });
      setAddingNotes(false);
    }
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title="Add Notes"
      maxWidth="620px"
      footer={
        <div className="flex justify-end w-full gap-3">
          <DillButton label="Cancel" variant="secondary" onClick={handleCloseModal} />
          <DillButton
            label="Add Notes"
            onClick={handleSubmit}
            isLoading={addingNotes}
            isDisabled={!creditApplication || addingNotes}
          />
        </div>
      }>
      <AppInputField
        isRequired
        label="Notes"
        value={notes}
        placeholder="Enter your notes"
        onTextChange={(setValue) => setNotes(setValue)}
        inputType="textarea"
        errorText={errorFields.includes('notes') ? 'Notes is required' : ''}
      />
    </DillModal>
  );
};

export default CreditApplicationNotesModal;
